import { useCallback } from 'react'
import { useHeaderState } from './useHeaderState'

export const useMenuTimeouts = () => {
  const { timeouts, setTimeoutId, clearTimeoutId, clearAllTimeouts } =
    useHeaderState()

  const TIMEOUT_DURATION = 5000

  // Clear all timeouts function using consolidated state
  const clearAllTimeoutsEnhanced = useCallback(() => {
    clearAllTimeouts()
  }, [clearAllTimeouts])

  const setViewFilesTimeout = useCallback(
    callback => {
      clearTimeoutId('viewFilesTimeoutId')
      const timeoutId = setTimeout(callback, TIMEOUT_DURATION)
      setTimeoutId('viewFilesTimeoutId', timeoutId)
    },
    [clearTimeoutId, setTimeoutId]
  )

  const setKinCategoriesTimeout = useCallback(
    callback => {
      clearTimeoutId('kinCategoriesTimeoutId')
      const timeoutId = setTimeout(callback, TIMEOUT_DURATION)
      setTimeoutId('kinCategoriesTimeoutId', timeoutId)
    },
    [clearTimeoutId, setTimeoutId]
  )

  const setAccountTimeout = useCallback(
    callback => {
      clearTimeoutId('accountTimeoutId')
      const timeoutId = setTimeout(callback, TIMEOUT_DURATION)
      setTimeoutId('accountTimeoutId', timeoutId)
    },
    [clearTimeoutId, setTimeoutId]
  )

  const setBuildYourOwnTimeout = useCallback(
    callback => {
      clearTimeoutId('buildYourOwnTimeoutId')
      const timeoutId = setTimeout(callback, TIMEOUT_DURATION)
      setTimeoutId('buildYourOwnTimeoutId', timeoutId)
    },
    [clearTimeoutId, setTimeoutId]
  )

  const toggleViewFilesMenuWithTimeout = useCallback(
    (isVisible, setIsVisible) => {
      // Clear other timeouts
      clearTimeoutId('kinCategoriesTimeoutId')
      clearTimeoutId('uploadTimeoutId')
      clearTimeoutId('accountTimeoutId')

      if (!isVisible) {
        const timeoutId = setTimeout(() => {
          setIsVisible(false)
        }, TIMEOUT_DURATION)
        setTimeoutId('viewFilesTimeoutId', timeoutId)
      } else {
        clearTimeoutId('viewFilesTimeoutId')
      }
    },
    [clearTimeoutId, setTimeoutId]
  )

  const toggleCreateKinCategoryMenuWithTimeout = useCallback(
    (isVisible, setIsVisible) => {
      clearTimeoutId('viewFilesTimeoutId')
      clearTimeoutId('uploadTimeoutId')
      clearTimeoutId('accountTimeoutId')
      clearTimeoutId('buildYourOwnTimeoutId')

      if (!isVisible) {
        const timeoutId = setTimeout(() => {
          setIsVisible(false)
        }, TIMEOUT_DURATION)
        setTimeoutId('kinCategoriesTimeoutId', timeoutId)
      } else {
        clearTimeoutId('kinCategoriesTimeoutId')
      }
    },
    [clearTimeoutId, setTimeoutId]
  )

  const toggleAccountMenuWithTimeout = useCallback(
    (isVisible, setIsVisible) => {
      clearTimeoutId('viewFilesTimeoutId')
      clearTimeoutId('uploadTimeoutId')
      clearTimeoutId('kinCategoriesTimeoutId')
      clearTimeoutId('buildYourOwnTimeoutId')

      if (!isVisible) {
        const timeoutId = setTimeout(() => {
          setIsVisible(false)
        }, TIMEOUT_DURATION)
        setTimeoutId('accountTimeoutId', timeoutId)
      } else {
        clearTimeoutId('accountTimeoutId')
      }
    },
    [clearTimeoutId, setTimeoutId]
  )

  return {
    // Timeout IDs
    viewFilesTimeoutId: timeouts.viewFilesTimeoutId,
    kinCategoriesTimeoutId: timeouts.kinCategoriesTimeoutId,
    uploadTimeoutId: timeouts.uploadTimeoutId,
    accountTimeoutId: timeouts.accountTimeoutId,
    buildYourOwnTimeoutId: timeouts.buildYourOwnTimeoutId,

    // Timeout setters
    setViewFilesTimeout,
    setKinCategoriesTimeout,
    setAccountTimeout,
    setBuildYourOwnTimeout,

    // Clear functions
    clearAllTimeouts: clearAllTimeoutsEnhanced,

    // Enhanced toggle functions with timeout handling
    toggleViewFilesMenuWithTimeout,
    toggleCreateKinCategoryMenuWithTimeout,
    toggleAccountMenuWithTimeout,

    // Direct timeout setters
    setViewFilesTimeoutId: timeoutId =>
      setTimeoutId('viewFilesTimeoutId', timeoutId),
    setKinCategoriesTimeoutId: timeoutId =>
      setTimeoutId('kinCategoriesTimeoutId', timeoutId),
    setUploadTimeoutId: timeoutId => setTimeoutId('uploadTimeoutId', timeoutId),
    setAccountTimeoutId: timeoutId =>
      setTimeoutId('accountTimeoutId', timeoutId),
    setBuildYourOwnTimeoutId: timeoutId =>
      setTimeoutId('buildYourOwnTimeoutId', timeoutId)
  }
}
